// extracted by mini-css-extract-plugin
module.exports = {"Pill":"Pill-2SZ8o","CrossIconContainer":"CrossIconContainer-qg1aN","CrossIcon":"CrossIcon-1M7zr"};